/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export class ClockTypes {
    public static readonly COLLECTION_SCREEN_CLOCK = 'clock collection-screen-clock';

    public static readonly DEFAULT_CLOCK: string = 'clock';

    public static readonly GUIDE_CLOCK: string = 'clock guide-clock';

    public static readonly OLG_CLOCK: string = 'clock olg-clock';

    public static readonly SETTINGS_HEADER_CLOCK: string = 'clock settings-header-clock';

    public static readonly SETTINGS_HEADER_CLOCK_WITH_VIDEO_WINDOW: string =
        'clock settings-header-clock video-window-clock';

    public static readonly WATCH_VIDEO_CLOCK: string = 'clock watch-video-clock';

    public static readonly HOME_SCREEN_NAV_CLOCK: string = 'clock home-screen-nav-clock';
}
